<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import NavCard from '@/components/NavCard/NavCard.vue'

const store = useStore()

const creditsBalance = computed(() => store.getters.user_info.credit_balance)
</script>

<template>
  <NavCard
    :item="{
      title: creditsBalance,
      icon: 'mdi-poker-chip',
    }"
    class="navcard_menu"
    style="--clr-text: var(--clr-primary); --padding: 0 0.5rem"
    :hasSub="false"
  />
</template>

<style lang="scss" scoped></style>
